<template>
  <div class="content content-depotfinder">
    <div class="content__inner">
      <div class="wrapper">
        <BackButton @click="handleBack('/depotfinder')" />

        <NextArrowButton :nextStep="nextStep" />

        <Depositmodels />

        <div
          class="depotfinder__question text-centered wrapper wrapper--medium"
        >
          <UiHeadline
            tag="h1"
            size="large"
            theme="primary"
            align="center"
            class="depotfinder__headline"
          >
            {{ $t("depotfinder.assets.headline") }}
          </UiHeadline>

          <div class="mt-3">
            <AssetSlider />
          </div>

          <NextButton :nextStep="nextStep" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UiHeadline from "./../../components/Ui/Headline.vue";
import Depositmodels from "./../../components/DepositModels.vue";
import AssetSlider from "./../../components/AssetSlider.vue";
import BackButton from "./../../components/BackButton.vue";
import NextButton from "./../../components/NextButton.vue";
import NextArrowButton from "./../../components/NextArrowButton.vue";
import { backButtonMixin } from "./../../mixins/handleBackButton";

export default {
  mixins: [backButtonMixin],
  components: {
    Depositmodels,
    AssetSlider,
    BackButton,
    NextButton,
    NextArrowButton,
    UiHeadline
  },
  computed: {
    recommendedDeposit() {
      return this.$store.getters.getRecommendedDeposit;
    },
    nextStep() {
      let nextStep = "";
      // User chose option "bank" in Step "Decision"
      if (this.$store.getters.getDecisionState == "bank") {
        // asset value < 250k
        if (this.$store.getters.getAssetsState <= 6) {
          nextStep = "depotfinder.results";
          this.setRecommendedDeposit("MeinVermögen");
          // asset value >= 250k
        } else if (this.$store.getters.getAssetsState == 7) {
          nextStep = "depotfinder.results";
          this.setRecommendedDeposit("Vermögensverwaltung");
        }
        // User arrived from any other step
      } else {
        // asset value < 50k
        if (this.$store.getters.getAssetsState <= 2) {
          nextStep = "depotfinder.results";
          this.setRecommendedDeposit("DepotKomfort");
          // asset value >= 50k && < 200k
        } else if (
          this.$store.getters.getAssetsState >= 3 &&
          this.$store.getters.getAssetsState <= 5
        ) {
          nextStep = "depotfinder.services";
          this.setRecommendedDeposit("");
          // asset value >= 200k
        } else if (this.$store.getters.getAssetsState >= 6) {
          nextStep = "depotfinder.results";
          this.setRecommendedDeposit("DepotExklusiv");
        }
      }
      return nextStep;
    }
  },
  methods: {
    setRecommendedDeposit(value) {
      this.$store.dispatch("updateRecommendedDeposit", value);
    }
  },
  mounted() {
    this.setRecommendedDeposit("");
  }
};
</script>
